import {
  PERMISSIONS_LOADING,
  PERMISSIONS_LOADED,
  PERMISSIONS_FAILED,
  PERMISSIONS_CLEARED,
} from '../actions/PermissionActions';

const initialState = {
  permissions:   [],   // [{ moduleId, moduleName, access: { view, add, update, delete } }]
  menus:         [],   // dynamic sidebar/menu tree from DB
  isSuperAdmin:  false,
  loading:       false,
  error:         null,
};

export function PermissionReducer(state = initialState, action) {
  switch (action.type) {
    case PERMISSIONS_LOADING:
      return { ...state, loading: true, error: null };

    case PERMISSIONS_LOADED:
      return {
        ...state,
        loading:      false,
        isSuperAdmin: Boolean(action.payload.isSuperAdmin),
        permissions:  Array.isArray(action.payload.permissions) ? action.payload.permissions : [],
        menus:        Array.isArray(action.payload.menus) ? action.payload.menus : [],
        error:        null,
      };

    case PERMISSIONS_FAILED:
      return { ...state, loading: false, error: action.payload };

    case PERMISSIONS_CLEARED:
      return initialState;

    default:
      return state;
  }
}